export enum ButtonActionType {
  LINK = 'LINK',
  RSVP = 'RSVP',
}
